const dealboxx_subscriber_link= "https://dealboxx.promo";
const localDomain = "https://localhost:3000";
const devBackendDomain="https://backend.dealboxx.promo/api/";
const vendor_url = "https://vendor.dealboxx.promo/";

const Config = {
  dealboxx_subscriber_link: dealboxx_subscriber_link,
  localDomain: localDomain,
  devBackendDomain: devBackendDomain,
  vendor_url: vendor_url,
}

export default Config;